import React, { Fragment } from "react";
import { BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";

const getReturnAndBreadcrumbs = (custom_form, parent_object, redirectToParent) => {
  let breadcrumbs = null;
  let initialValues = null;
  let returnUrl = `/custom_form/${custom_form?.id}/records`;

  // If there is a parent object passed
  if (parent_object && redirectToParent) {
    switch (custom_form?.parent_type) {
      case "Project":
        returnUrl = `/projects/${parent_object?.id}/show?tab=cf${custom_form?.id}`;
        break;
      case "Employee":
        returnUrl = `/employees/${parent_object?.id}/show?tab=cf${custom_form?.id}`;
        break;
      case "CustomForm":
        returnUrl = `/custom_form/${custom_form?.parent_id}/records/${parent_object?.id}/open?tab=cf${custom_form?.id}`;
        break;
    }
  }

  if (custom_form?.parent_type && parent_object) {
    initialValues = { parent_id: parent_object?.id, parent_type: custom_form?.parent_type };
    breadcrumbs = (
      <Fragment>
        <BreadcrumbItem>
          <Link to={returnUrl}>
            {parent_object?.display_name} - {custom_form?.name}s
          </Link>
        </BreadcrumbItem>
      </Fragment>
    );
  } else {
    breadcrumbs = (
      <Fragment>
        <BreadcrumbItem>
          <Link to={returnUrl}>{custom_form?.name}s</Link>
        </BreadcrumbItem>
      </Fragment>
    );
  }

  return { breadcrumbs, returnUrl, initialValues };
};

export default getReturnAndBreadcrumbs;
